<template>
  <div>
    <span v-if="data.column.field === 'name'">
      <div>
        <b-link :to="`nativeads/edit/${data.row.id}`">{{ data.row.name }}</b-link>
      </div>
    </span>
    <span v-else-if="data.column.field === 'insertDateTime'">
      {{ new Date(Date.parse(data.row.insertDateTime)).toLocaleString() }}
    </span>
    <span v-else-if="data.column.field === 'updateDateTime'">
      {{ new Date(Date.parse(data.row.updateDateTime)).toLocaleString() }}
    </span>
    <span v-else-if="data.column.field === 'actions'">
      <div class="d-flex justify-content-end">
        <b-button
          variant="link"
          class="p-0"
          :to="`nativeads/edit/${data.row.id}`"
        >
          <GjIcon
            name="Edit"
            class="text-primary"
          />
        </b-button>
      </div>
    </span>

    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
}
</script>
